"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SendNickName = () => {
    const [nickName, setNickName] = (0, react_1.useState)('');
    const handleNickName = (e) => {
        setNickName(e.target.value);
    };
    const sendNickName = (e) => {
        e.preventDefault();
        console.log(nickName);
    };
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            flex: "auto",
            justifyContent: "center",
            background: "tomato"
        } },
        react_1.default.createElement("form", { onSubmit: sendNickName, style: {
                display: "flex",
                flexFlow: "column nowrap",
                maxWidth: "50%",
                justifyContent: "center"
            } },
            react_1.default.createElement("label", { htmlFor: "nickName", style: {
                    marginBottom: "50px",
                    textAlign: "center",
                    fontSize: "0.9rem"
                } },
                react_1.default.createElement("h2", null, "\uB300\uD654\uC5D0 \uC0AC\uC6A9\uD558\uC2E4 \uB2C9\uB124\uC784\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.")),
            react_1.default.createElement("input", { type: "text", id: "nickName", value: nickName, onChange: handleNickName }),
            react_1.default.createElement("button", { type: "button" }, "\uCC44\uD305\uC2DC\uC791"))));
};
exports.default = SendNickName;
